
import { Injectable } from '@angular/core';
import { ApiObjectData } from '../models/api-object-data';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';
import { ChangePassword } from './../models/change-password';
import { User } from 'src/app/core/models/user';

@Injectable({
    providedIn: 'root'
})

export class UserService {
    controller = 'User';

    constructor(private base: BaseService) { }

    changePassword(obj: ChangePassword) {
        return this.base.save(this.controller + '/ChangePassword', obj);
    }


    forgetPassword(obj: User) {
        return this.base.save(this.controller + '/ForgetPassword', obj);
    }

    getUserByUserNameOrEmail(userData: string) {
        return this.base.gets(this.controller + '/GetUserByUserNameOrEmail/' + userData);
    }
}
